import React, {useEffect,useMemo,useRef,useState} from 'react';
import { stockConfiguration, stockTeam } from './stockHistory';
import { enqueueStockParsed } from './stockCapture';

export default function StockParsedCapture({state,buildReport}) {
  const last=useRef(null);
  const [notice,setNotice]=useState('');
  const team=stockTeam(state);
  const {mergedParts,callList,stockPowerBI,stockCalls,clients,clientPartIds,clientPartIdsTeam,gradingLookup,gradeValues,callListFile}=state;
  const configuration=useMemo(()=>stockConfiguration({clients,clientPartIds,clientPartIdsTeam,gradingLookup,gradeValues},callListFile ? Object.fromEntries(Object.entries(callListFile).filter(([k])=>k.endsWith('Col'))) : {}),[clients,clientPartIds,clientPartIdsTeam,gradingLookup,gradeValues,callListFile]);
  useEffect(()=>{
    const sources={};
    if(stockPowerBI?.team===team) sources.powerbi=stockPowerBI.eventId;
    if(stockCalls?.team===team) sources.calls=stockCalls.eventId;
    if(!team || (!sources.powerbi && !sources.calls) || (mergedParts?.length && !sources.powerbi) || (callList?.length && !sources.calls)) {
      setNotice('To archive this parsed report, upload its Power BI / calls for '+(team || 'the selected team')+'. Previously loaded inputs need an original source file before they can be saved to stock history.');
      return;
    }
    const marker=[team,mergedParts,callList,stockPowerBI,stockCalls,configuration];
    if(last.current && marker.every((v,i)=>v===last.current[i])) return;
    last.current=marker;setNotice('');
    enqueueStockParsed({team,sources,configuration,report:buildReport({mergedParts,callList,gradeValues})});
  },[team,mergedParts,callList,stockPowerBI,stockCalls,configuration,gradeValues,buildReport]);
  return notice?<p role="status" style={{fontSize:12,color:'#e7b16e',padding:12,lineHeight:1.7}}>{notice}</p>:null;
}
